var app = angular.module("leonardo");

var SubgroupListActions = function($scope, ngDialog) {
  $scope.addSubgroup = function(){
    ngDialog.open({
      controller: 'SubgroupEditDialog',
      templateUrl: 'views/templates/dialog/admin/fields/subgroup.html',
      data: {
        subgroup: null
      }
    });
  };
};

app.controller('SubgroupListActions', ['$scope', 'ngDialog', SubgroupListActions]);
